import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useSession } from '../lib/session';
import { credits } from '../lib/ui';
import { THEMES } from '../lib/themes';
import { W360Logo } from './W360Logo';

/** Host app shell: shared balance and navigation. The casino is the staff console: no demo strip, a CONSOLE tag by the logo (owner 2026-10-20). */
export default function Shell() {
  const { me, balance, logout, hasRole } = useSession();
  const nav = useNavigate();
  return (
    <div className="app">
      <header className="topbar">
        <NavLink to="/" className="brand brand-logo" aria-label="W360 Casino — lobby">
          <W360Logo variant="header" />
          <span className="brand-tag">CONSOLE</span>
        </NavLink>
        {me && (
          <nav className="nav" aria-label="Main">
            {me.roles.includes('provider_admin') && <NavLink to="/provider">Provider back office</NavLink>}
            <NavLink to="/" end>
              Lobby
            </NavLink>
            <NavLink to="/tables">Tables</NavLink>
            {THEMES.map((t) => (
              <NavLink key={t.id} to={t.path}>
                {t.nav}
              </NavLink>
            ))}
            <NavLink to="/history">History</NavLink>
            {hasRole('operator', 'presenter') && !me.roles.includes('provider_admin') && <NavLink to="/admin">Operator admin</NavLink>}
            {hasRole('skin_editor', 'studio_admin') && <NavLink to="/editor">Skin editor</NavLink>}
          </nav>
        )}
        {me && !me.roles.includes('provider_admin') && (
          <div className="balance-pill" aria-live="polite" data-testid="header-balance">
            <span className="lbl">Balance</span>
            <span className="amt">{credits(balance?.balance)}</span>
          </div>
        )}
        {me ? (
          <button
            className="user-btn"
            onClick={async () => {
              await logout();
              nav('/login');
            }}
            title="Sign out"
          >
            {me.displayName} · Sign out
          </button>
        ) : null}
      </header>
      <Outlet />
    </div>
  );
}
